import { Routes } from '@angular/router';
import { MpsLoggedInGuard } from '../../../mps/mps-guards';
import { MyAccountComponent } from './components/my-account/my-account.component';

export const routes: Routes = [
  {
    path: 'user',
    children: [
      { path: 'my-account', component: MyAccountComponent, canActivate: [MpsLoggedInGuard] }
    ]
  }
];

